/**
 * ユーティリティー
 * 文字列関連
 *
 * No.    日付          更新者    更新内容
 *   1    2017/10/               新規作成
 *
 * @summary ユーティリティー文字列関連
 * @copyright 2017, WINGSYSTEMS K.K.
 */
'use strict';

const Util = {};
const Str = Util.String = {};
export {Str};

/**
 * Snake ⇒ Camel 変換
 * @param {string} s 対象文字列
 * @returns {string} 変換後文字列
 */
Str.toCamel = function(s) {
  s = s.charAt(0).toLowerCase() + s.slice(1);
  return s.replace(/[-_](.)/g, function(match, group1) {
    return group1.toUpperCase();
  });
};

/**
 * Camel ⇒ Snake 変換
 * @param {string} s 対象文字列
 * @returns {string} 変換後文字列
 */
Str.toSnake = function(s) {
  var camel = Str.toCamel(s);
  return camel.replace(/[A-Z]/g, function(s) {
    return '_' + s.charAt(0).toLowerCase();
  });
};

/**
 * Cnake ⇒ Pascal 変換
 * @param {string} s 対象文字列
 * @returns {string} 変換後文字列
 */
Str.toPascal = function(s) {
  var camel = Str.toCamel(s);
  return camel.charAt(0).toUpperCase() + camel.slice(1);
};

/**
 * Camel ⇒ Kebab 変換
 * @param {string} s 対象文字列
 * @returns {string} 変換後文字列
 */
Str.camelToKebab = function(camel) {
  return camel.replace(/[A-Z]/g, function(s) {
    return '-' + s.charAt(0).toLowerCase();
  });
};

// エスケープ処理
Str.escapeSpecialChars = function(orgStr) {
  if (orgStr === null) {
    return orgStr;
  }
  var str = orgStr;
  str = str.replace(/\\/g, '\\\\');
  str = str.replace(/\r?\n/g, '\\n');
  str = str.replace(/"/g, '\\"');
  return str;
};

Str.escapeHtml = (function(String) {  // eslint-disable-line no-unused-vars
  var escapeMap = {
    '&': '&amp;',
    "'": '&#x27;',
    '`': '&#x60;',
    '"': '&quot;',
    '<': '&lt;',
    '>': '&gt;'
  };
  var escapeReg = '[';
  var reg;
  for (var p in escapeMap) {
    if (escapeMap && Object.prototype.hasOwnProperty.call(escapeMap, p)) {
      escapeReg += p;
    }
//    if (escapeMap.hasOwnProperty(p)) {
//      escapeReg += p;
//    }
  }
  escapeReg += ']';
  reg = new RegExp(escapeReg, 'g');

  return function escapeHtml (str) {
    str = (str === null || str === undefined) ? '' : '' + str;
    return str.replace(reg, function(match) {
      return escapeMap[match];
    });
  };
}(String));

// 文字列内からSCRIPTタグを取り除く
Str.stripTagByScript = function(target) {
  var lt = String.fromCharCode(60);
  var gt = String.fromCharCode(62);
  var pat = lt+"S"+"CRIPT[^"+gt+"]*"+gt+"[^"+lt+"]+"+lt+"/S"+"CRIPT"+gt;
  var reg = new RegExp(pat,"ig");
  return target.replace(reg,"");
};

// 住所加工
Str.formatAddress = function(zip, address1, address2) {
  var convertZip = '';
  if (zip !== '') {
    if (!String.prototype.padStart) {
      convertZip = '〒 '+Str.padStart(zip.slice(0,3), 3)+' - '+Str.padStart(zip.slice(3), 4)+'\n';
    } else {
      convertZip = '〒 '+zip.slice(0,3).padStart(3)+' - '+zip.slice(3).padStart(4)+'\n';
    }
  }
  var adr1 = address1 || '';
  var adr2 = address2 || '';
  var address = convertZip + adr1 + adr2;
  return address;
};

Str.padStart = function(target, targetLength, padString) {
  targetLength = targetLength >> 0; // truncate if number or convert non-number to 0;
  padString = String((typeof padString !== 'undefined' ? padString : ' '));
  if (this.length > targetLength) {
    return String(target);
  } else {
    targetLength = targetLength - target.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); // append to original to ensure we are longer than needed
    }
    return padString.slice(0, targetLength) + String(target);
  }
};
